import { IconViewer } from '@vfmfe/foundations';
import AmigoIcon from '../../../assets/AmigoIcon';
import LivroReclamacoesIcon from '../../../assets/LivroReclamacoesIcon';
import { useFooter } from '../../../hooks';
import { mapFooterDataToProps } from '../VodafoneFooter/VodafoneFooterAdapter';
import {
    BottomLinks,
    Column,
    Container,
    Copyright,
    FooterBottom,
    FooterLeft,
    FooterLinks,
    FooterTop,
    FooterWrapper,
    Logo,
    Socials
} from './AmigoFooter.styles';
import { getSocialMediaIconFromName } from './utils';

function AmigoFooter() {
    const logoClickHandler = () => {
        window.location.reload();
    };

    const { footerData, loading } = useFooter({ name: 'digital_amigo_footer' });

    if (loading || !footerData) {
        return null;
    }

    const footerConfigs = mapFooterDataToProps(footerData);

    return (
        <FooterWrapper>
            <Container>
                <FooterTop>
                    <FooterLeft>
                        <Logo onClick={logoClickHandler}>
                            <AmigoIcon />
                        </Logo>
                        <Socials>
                            {footerConfigs.socialLinksProps.links.map((socialLink, index) => {
                                const { url, ariaLabel, name } = socialLink;
                                return (
                                    <a key={index} href={url} aria-label={ariaLabel}>
                                        {getSocialMediaIconFromName(name?.toLowerCase() || '') || (
                                            <IconViewer name="link" size={5} />
                                        )}
                                    </a>
                                );
                            })}
                        </Socials>
                    </FooterLeft>
                    <FooterLinks>
                        {Object.entries(footerConfigs.linkGroupProps).map(([groupTitle, group], index) => (
                            <Column key={index}>
                                <h4>{groupTitle}</h4>
                                <ul>
                                    {group.map((link, linkIndex) => (
                                        <li key={linkIndex}>
                                            <a href={link.url}>{link.label}</a>
                                        </li>
                                    ))}
                                </ul>
                            </Column>
                        ))}
                    </FooterLinks>
                </FooterTop>

                <FooterBottom>
                    <BottomLinks>
                        {footerConfigs.quickLinks.map((link, index) => (
                            <a key={index} href={link.url}>
                                {link.name.toLowerCase() === 'livro_de_reclamacoes' ? (
                                    <LivroReclamacoesIcon />
                                ) : (
                                    link.label
                                )}
                            </a>
                        ))}
                    </BottomLinks>
                    <Copyright>{footerConfigs.copyright}</Copyright>
                </FooterBottom>
            </Container>
        </FooterWrapper>
    );
}

export default AmigoFooter;
